import React, { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeApplier: React.FC = () => {
  const { theme } = useTheme();

  useEffect(() => {
    if (theme) {
      const root = document.documentElement;

      root.style.setProperty('--primary-color', theme.primary_color);
      root.style.setProperty('--secondary-color', theme.secondary_color);
      root.style.setProperty('--text-color', theme.text_color);
      root.style.setProperty('--background-color', theme.background_color);
      root.style.setProperty('--accent-color', theme.accent_color);
      root.style.setProperty('--success-color', theme.success_color || theme.accent_color);
      root.style.setProperty('--warning-color', theme.warning_color || '#FF9800');
      root.style.setProperty('--error-color', theme.error_color || '#F44336');
      root.style.setProperty('--info-color', theme.info_color || '#2196F3');
      root.style.setProperty('--border-color', theme.border_color || '#3a3d52');
      root.style.setProperty('--card-color', theme.card_color || '#252838');
      root.style.setProperty('--header-color', theme.header_color || '#1e2139');
      root.style.setProperty('--footer-color', theme.footer_color || '#0A2540');

      // Remove existing theme style if any
      const existingStyle = document.getElementById('dynamic-theme-style');
      if (existingStyle) existingStyle.remove();

      const style = document.createElement('style');
      style.id = 'dynamic-theme-style';
      style.textContent = `
        * {
          font-family: ${theme.font_family || 'Poppins'}, 'Inter', sans-serif !important;
        }

        body:not(.login-page-active) {
          background-color: ${theme.background_color} !important;
          color: ${theme.text_color} !important;
        }

        html:not(.login-page-active) {
          background-color: ${theme.background_color} !important;
        }

        #root {
          background-color: transparent !important;
          min-height: 100vh !important;
        }

        /* Dark theme overrides for MUI components */
        .MuiDrawer-paper {
          background-color: ${theme.secondary_color} !important;
          color: ${theme.text_color} !important;
          border-right: 1px solid #1e2139 !important;
        }

        .MuiTypography-root:not(.login-page .MuiTypography-root) {
          color: ${theme.text_color} !important;
        }

        .MuiTableCell-root {
          color: ${theme.text_color} !important;
          border-color: ${theme.border_color || '#3a3d52'} !important;
        }

        .MuiTableHead-root {
          background-color: #1a1d2e !important;
        }

        .MuiInputBase-root {
          color: ${theme.text_color} !important;
        }

        /* Chart styling */
        .recharts-tooltip-wrapper {
          background-color: #252838 !important;
          border: 1px solid ${theme.border_color || '#3a3d52'} !important;
          color: ${theme.text_color} !important;
        }

        .recharts-default-tooltip {
          background-color: #252838 !important;
          border: 1px solid ${theme.border_color || '#3a3d52'} !important;
        }

        .recharts-legend-item-text {
          color: ${theme.text_color} !important;
        }

        .recharts-cartesian-axis-tick-value {
          fill: #9ca3af !important;
        }

        .recharts-cartesian-grid-horizontal line,
        .recharts-cartesian-grid-vertical line {
          stroke: ${theme.border_color || '#3a3d52'} !important;
        }
      `;

      document.head.appendChild(style);
    }
  }, [theme]);

  return null;
};

export default ThemeApplier;
